var _path, _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Device profile IMG/LOGO"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5196_94643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16446 0H1.76129H0V1.8348V6.42183H1.76129V1.8348H6.16446V0ZM12.1354 15.8882H7.58954L6.40401 18.5763H4.67807L9.93573 6.81511L15.0049 18.5763H13.2515L12.1354 15.8882ZM11.4837 14.3194L9.90694 10.5558L8.25559 14.3194H11.4837ZM18.1533 7.51004V18.5763H16.5503V7.51004H18.1533ZM1.76141 23.1652V18.5782H0.000122069V23.1652V25H1.76141H6.16458V23.1652H1.76141ZM22.2387 23.1652V18.5782H24V23.1652V25H22.2387H17.8355V23.1652H22.2387ZM17.8355 0H22.2387H24V1.8348V6.42183H22.2387V1.8348H17.8355V0Z",
    fill: "#302159"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5196_94643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 39447",
    filter: "url(#filter0_b_5196_94643)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9998,
    height: 25.0001,
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.675694,
    y: 0.675694,
    width: 22.6484,
    height: 23.6487,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.35139,
    style: {
      mixBlendMode: "overlay"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2168",
    filter: "url(#filter1_f_5196_94643)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.6671,
    cy: 2.2228,
    rx: 12.9249,
    ry: 13.2726,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2171",
    filter: "url(#filter2_f_5196_94643)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.00009,
    cy: 2.2228,
    rx: 12.9249,
    ry: 13.2726,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2169",
    filter: "url(#filter3_f_5196_94643)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.39128,
    cy: 30.1737,
    rx: 15.9499,
    ry: 16.4237,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2170",
    opacity: 0.5,
    filter: "url(#filter4_f_5196_94643)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1331,
    cy: 12.5695,
    rx: 8.59993,
    ry: 8.81947,
    fill: "url(#paint0_linear_5196_94643)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 39448",
    filter: "url(#filter5_b_5196_94643)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9998,
    height: 25.0001,
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5196_94643",
    x: -54.0556,
    y: -54.0556,
    width: 132.111,
    height: 133.111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 27.0278
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5196_94643"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5196_94643",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5196_94643",
    x: -86.2578,
    y: -111.05,
    width: 225.85,
    height: 226.545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_5196_94643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_5196_94643",
    x: -104.925,
    y: -111.05,
    width: 225.85,
    height: 226.545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_5196_94643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_5196_94643",
    x: -92.5586,
    y: -66.25,
    width: 191.899,
    height: 192.848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_5196_94643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_5196_94643",
    x: -73.4668,
    y: -76.25,
    width: 177.2,
    height: 177.639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_5196_94643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_5196_94643",
    x: -54.0556,
    y: -54.0556,
    width: 132.111,
    height: 133.111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 27.0278
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5196_94643"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5196_94643",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5196_94643",
    x1: 15.1331,
    y1: 3.75,
    x2: 15.1331,
    y2: 21.3889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59941"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.eeb13bbdb0c416a748a6ba18759de55e.svg";
export { ForwardRef as ReactComponent };